import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT } from '../../../constants';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';
import { handleTreesPaymentCookie } from '../../../services/modal/TreesPaymentModal/utils';

import SvgComponent from '../../SvgComponent';
import LinkButtonComponent from '../../button/LinkButtonComponent';

import './TreesPaymentModal.scss';

class TreesPaymentModal extends React.Component {
    componentWillUnmount() {
        handleTreesPaymentCookie();
    }

    render() {
        const { i18n } = this.props;

        return (
            <div className="modal-trees-payment">
                <div className="header">
                    <h3>{convertHtmlToReactDomWithParams(i18n.TITLE)}</h3>
                </div>

                <div className="body">
                    <p className="highlight-message">
                        {convertHtmlToReactDomWithParams(i18n.TEXT_1)}
                    </p>

                    <div className="offer">
                        <div className="item">
                            <div className="number">{i18n.TEXT_2}</div>
                            <div className="text">
                                {convertHtmlToReactDomWithParams(i18n.TEXT_3)}
                            </div>
                        </div>
                        <div className="equals">{i18n.TEXT_4}</div>
                        <div className="item">
                            <div className="number">{i18n.TEXT_5}</div>
                            <div className="text">
                                {convertHtmlToReactDomWithParams(i18n.TEXT_6)}
                            </div>
                        </div>
                    </div>

                    <div className="frame">
                        <div className="over-border">
                            <p>{i18n.FRAME_TEXT_1}</p>
                        </div>

                        <ol>
                            <li>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/modal/treespayment/cloud.svg`}
                                    alt=""
                                    width="117"
                                    height="98"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                                <div className="text">
                                    <p>{convertHtmlToReactDomWithParams(i18n.FRAME_TEXT_2)}</p>
                                </div>
                            </li>
                            <li>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/modal/treespayment/bird.svg`}
                                    alt=""
                                    width="117"
                                    height="98"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                                <div className="text">
                                    <p>{convertHtmlToReactDomWithParams(i18n.FRAME_TEXT_3)}</p>
                                </div>
                            </li>
                            <li>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/modal/treespayment/trees.svg`}
                                    alt=""
                                    width="117"
                                    height="98"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                                <div className="text">
                                    <p>{convertHtmlToReactDomWithParams(i18n.FRAME_TEXT_4)}</p>
                                </div>
                            </li>
                        </ol>
                    </div>

                    <div className="button-wrapper">
                        <LinkButtonComponent
                            id="link-button"
                            to={`${PATH.ACCOUNT_JACKPOT_PATH}#trees`}
                            text={i18n.BUTTON_TEXT}
                            color="main"
                        />
                    </div>
                </div>

                <div className="footer">{i18n.FOOTER_TEXT}</div>
            </div>
        );
    }
}

TreesPaymentModal.propTypes = {
    i18n: PropTypes.object
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.TREES_PAYMENT_MODAL
    };
};

export default connect(mapStateToProps)(TreesPaymentModal);



// WEBPACK FOOTER //
// ./src/components/modal/TreesPaymentModal/TreesPaymentModal.js